import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const HeadSection = props => {
  const { color, content, } = props
  const classes = useStyles({ color, })
  return (
    <div className={classes.headSection}>
      <div className={classes.ornament}>
        <div className={classes.ornamentBoxLeft}/>
      </div>
      <p className={classes.headContent}>{content}</p>
      <div style={{ alignItems: 'flex-end', }} className={classes.ornament}>
        <div className={classes.ornamentBoxRight}/>
      </div>
    </div>
  )
}

HeadSection.propTypes = {
  color: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
}

const useStyles = createUseStyles({
  headSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '3em',
  },
  ornament: {
    display: 'flex',
    position: 'relative',
    '& div': {
      width: '40px',
      height: '40px',
    },
  },
  ornamentBoxRight: props => ({
    borderBottom: `3px solid ${props.color}`,
    borderRight: `3px solid ${props.color}`,
    marginLeft: '-1em',
    marginBottom: '-0.7em',
  }),
  ornamentBoxLeft: props => ({
    borderTop: `3px solid ${props.color}`,
    borderLeft: `3px solid ${props.color}`,
    marginRight: '-0.7em',
    marginTop: '-0.7em',
  }),
  headContent: {
    color: '#6b7671',
    fontSize: '22px',
    textAlign: 'center',
  },
})

export default HeadSection
